import * as echarts from 'echarts';
import React, { useEffect, useRef } from "react";
import Requestor from "../../../requestor";
import { SttledStatisticsType } from "../../../constants/dashbord"

type EChartsOption = echarts.EChartsOption;

const DashbordPage: React.FC = () => {
  const chartRef = useRef<any>(null)

  const initData = async() => {
    try {
      const res = await Requestor.getSttledStatistics<SttledStatisticsType[]>()
      if (res.error !== '') {
        throw res.error
      }
      initChart(res.result || [])
      autoRefresh()
    } catch(e) {
      console.log(e);
    }
 }

  const initChart = (datas: SttledStatisticsType[]) => {
    const chartDom = document.getElementById('account')!;
    chartRef.current = echarts.init(chartDom);
    const option: EChartsOption = {
      title: {
        text: '结算趋势',
        left: 'center',
        bottom: 0
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['已结算', '未结算'],
      },
      grid: {
        bottom: '60px',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: datas.map((el: SttledStatisticsType)  => el.date)
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: '已结算',
          type: 'line',
          stack: 'Total',
          data: datas.map((el: SttledStatisticsType)  => el.settled / 100)
        },
        {
          name: '未结算',
          type: 'line',
          stack: 'Total',
          data: datas.map((el: SttledStatisticsType)  => el.notSettled / 100)
        },
      ]
    };

    option &&  chartRef.current.setOption(option);
  }

  // 自动刷新
  let timerA: NodeJS.Timer;
  const autoRefresh = () => {
    timerA = setTimeout(() => {
      try {
        initData()
      } catch (error) {
        
      } finally {
        clearTimeout(timerA)
      }
    }, 60000)
  }

  useEffect(() => {
    initData()
    return () => {
      if (timerA) clearTimeout(timerA)
    }
  },[])

  window.addEventListener('resize', function() {
    if (chartRef) {
      chartRef.current?.resize?.()
    }
  })

  return (
    <div>
      <div id="account" style={{ width: '100%', height:460 }}></div>
    </div>
  )
}

export default DashbordPage